/** ISO currency code stored on transactions / APIs. */
export const DEFAULT_CURRENCY_CODE = "XAF";

/** User-facing currency label. */
export const CURRENCY_LABEL = "FCFA";

/** Round to 2 decimal places (major currency units). */
export function roundMoney(amount?: number | string | null): number {
  const n = Number(amount);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

/**
 * Format a money amount for display.
 * - 100000 / 100000.00 → "100,000"
 * - 1000.32 → "1,000.32"
 */
export function formatMoneyAmount(amount?: number | string | null): string {
  const n = roundMoney(amount);
  const hasFraction = Math.round(n * 100) % 100 !== 0;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(n);
}

/** Format with FCFA suffix, e.g. "100,000 FCFA". */
export function formatMoney(
  amount?: number | string | null,
  options?: { showCurrency?: boolean },
): string {
  const formatted = formatMoneyAmount(amount);
  if (options?.showCurrency === false) return formatted;
  return `${formatted} ${CURRENCY_LABEL}`;
}
